export default __webpack_public_path__ + "static/media/IMG_44401.943149c0.jpeg";